<template>
  <v-container class="max-container">
    <v-row v-show="arrayOfPrizes.length > 0" class="no-pd">
        <v-col class="no-pd-b no-pd-t" xs="12" sm="12" md="12" lg="12" xl="12">
            <h2 class="prize__title"> Prêmios recebidos </h2>
        </v-col>

        <v-col v-show="arrayOfPrizes.length > 0" xs="12" sm="12" md="12" lg="12" xl="12" v-for="prize in arrayOfPrizes " :key="prize.id">
            <v-card 
                :class=" !$vuetify.breakpoint.xs?'flex-row-end--custom' : ' flex-col-center'" 
                :height="!$vuetify.breakpoint.xs? '100' : ''" 
                :max-height="!$vuetify.breakpoint.xs? '100' : '400'" 
                elevation
            >
                <v-img 
                    :height="!$vuetify.breakpoint.xs? '100' : '120'" 
                    :width="!$vuetify.breakpoint.xs? '160' : ''" 
                    :max-width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : '200'"
                    :src="prize.image? prize.image : 'https://lity-prod.s3-sa-east-1.amazonaws.com/images/LITY_GIFT.gif'"
                >
                </v-img>
                <div class="prize__text h-100" :style="!$vuetify.breakpoint.xs? 'max-height: 100px;' : 'max-height: 140px'">
                    <v-card-title class="text-bold" v-text="prize.title"> </v-card-title>
                    <v-card-subtitle class="prize__description" v-text="prize.description"></v-card-subtitle>
                </div>
                <v-btn :color="currentCompany.buttonsColor" text @click="goToPrizeDetail(prize.id)">
                    <span class="text-none"> Ver mais </span>
                </v-btn>
            </v-card>
        </v-col>
    </v-row>
    <!--Empty-->
    <v-row v-show="arrayOfPrizes.length <= 0" class="flex-col-center">
        <v-img class="div__emptyimg" src="@/assets/empty-views/empty_prizes.svg"/>
    </v-row>
  </v-container>
</template>

<script>
//Store
import { mapGetters } from "vuex";

//Services
import { getPendingPrizesByCompanyIdAndCurrentContactId } from "./service/prize.service";

export default {
    name: 'Prize',
    computed: {
        ...mapGetters('authenticateStore', {
                currentCompany: 'get_currentCompany'
            }
        )
    },
    data: () => ({
        arrayOfPrizes: []
    }),
    created() {
        this.getAllPrizes()
    },
    methods: {
        getAllPrizes() {
            getPendingPrizesByCompanyIdAndCurrentContactId( this.currentCompany.id )
                .then( success => {
                        this.arrayOfPrizes = success.data                  
                    }
                )
                .catch( error => {
                    if (error != null) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    }
                )
        },
        goToPrizeDetail(prizeId) {
            this.$router.push({path: `detalhePremio/?premioId=${prizeId}`})
        }
    }
}
</script>

<style scoped>
.prize__title {
    margin-bottom: 30px;
}
.prize__description {
    overflow: auto;
}
.prize__text {
    display: flex !important;
    flex: auto !important;
    flex-direction: column !important;
}
.flex-row-end--custom {
    display: flex !important;
    height: 100% !important;
    flex: auto !important;
    flex-direction: row !important;
    align-items: flex-end !important;
    justify-content: end !important;
}
.div__emptyimg {    
    width: 380px;
}
</style>